// Settings API client — Phase 4 Plan 04-07 (DIS-20).
//
// Wraps:
//   GET   /api/v1/me                                  (user profile)
//   PATCH /api/v1/me                                  (preferred_locale + notification_prefs)
//   PATCH /api/v1/companies/me/default-visibility     (owner-only — Plan 04-04 endpoint)

import type { ApiClient } from "./client";

export interface NotificationPrefs {
  dispatcher_alerts?: boolean;
  sound_critical?: boolean;
  alert_channels?: string[];
}

export interface UserMe {
  user_id: number;
  role: string;
  company_id: number | null;
  preferred_locale: string;
  notification_prefs: NotificationPrefs;
}

export interface UserMeUpdate {
  preferred_locale?: string;
  notification_prefs?: NotificationPrefs;
}

export interface VisibilitySettings {
  eta?: boolean;
  status?: boolean;
  driver_name?: boolean;
  driver_contact?: boolean;
  license_plate?: boolean;
  carrier_name?: boolean;
}

function _idempotencyKey(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random()}`;
}

export const settingsApi = {
  getMe(client: ApiClient): Promise<UserMe> {
    return client.get<UserMe>("/api/v1/me");
  },

  patchMe(client: ApiClient, updates: UserMeUpdate): Promise<UserMe> {
    return client.fetch<UserMe>("/api/v1/me", {
      method: "PATCH",
      body: JSON.stringify(updates),
    });
  },

  patchCompanyDefaultVisibility(
    client: ApiClient,
    updates: VisibilitySettings,
  ): Promise<VisibilitySettings> {
    return client.fetch<VisibilitySettings>("/api/v1/companies/me/default-visibility", {
      method: "PATCH",
      headers: { "Idempotency-Key": _idempotencyKey() },
      body: JSON.stringify(updates),
    });
  },
};
